angular.module('flipto.components.fieldEditors')
    .config(['$provide', '$compileProvider', function ($provide, $compileProvider) {
        $compileProvider.directive('ftBoolField', [function () {
            return {
                restrict: 'E',
                scope: {
                    disabledField: '=',
                    datasource: '=',
                    title: '@',
                    fields: '=' // optional binding (could also be passed as expression)
                },
                templateUrl: '/app/components/field-editors/boolField.html',
                link: function (scope, elem, attrs) {
                    // Helper to evaluate expression up the scope chain
                    function deepEval(scope, expression) {
                        var ctx = scope;
                        while (ctx) {
                            try {
                                var val = ctx.$eval(expression);
                                if (val !== undefined) return val;
                            } catch (e) {
                                // continue up
                            }
                            ctx = ctx.$parent;
                        }
                        return undefined;
                    }

                    // Adjust flat string array or mixed format to object format
                    function adjustFields(fields) {
                        return _.map(fields || [], function (field) {
                            if (angular.isString(field)) {
                                return { name: field, label: null };
                            }
                            return field;
                        });
                    }

                    // Watch the attribute expression (e.g., "model.fieldsForPlacePhoto")
                    scope.$watch(
                        function () {
                            return attrs.fields || attr.fieldsExpression;
                        },
                        function (expression) {
                            if (!expression) return;
                            var resolved = deepEval(scope, expression);
                            scope.fields = adjustFields(resolved);
                        }
                    );
                }
            };
        }]);
    }]);
